/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";
import { datadogRum } from "@datadog/browser-rum";

import * as API from "../../../../api/billing";
import Card from "../../../reusable/cardv2";
import EditPONumbersIcon from "../../../reusable/editPONumbersIcon";
import Modal from "../../../reusable/reactModal";
import UpdatePONumbersModalBody from "./updatePONumbersModalBody";
import { POData, PurchaseOrderNumbersCardPropTypes } from "../lib/types";

import { redesignTheme } from "../../../theme/theme";

const StyledText = styled.div`
  font-family: ${redesignTheme.fontFamily.interface};
  color: ${redesignTheme.color.gray900};
  font-size: ${redesignTheme.fontSize[100]};
`;

const StyledTextWithMargin = styled(StyledText)`
  margin-bottom: ${redesignTheme.spacing[4.5]};
`;

const StyledLabel = styled(StyledText)`
  font-weight: ${redesignTheme.fontWeight.semibold};
  display: block;
  margin-bottom: ${redesignTheme.spacing[1.5]};
`;

const PurchaseOrderNumbersCard = ({
  companyId,
  updateToastMessage,
}: PurchaseOrderNumbersCardPropTypes): React.ReactElement => {
  const [data, setData] = React.useState<POData>({});
  const [loading, setLoading] = React.useState<boolean>(true);
  const [showModal, setShowModal] = React.useState<boolean>(false);

  const fetchData = async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await API.getPurchaseOrderNumbers(companyId);
      setData(response.data.data);
      setLoading(false);
    } catch (error) {
      datadogRum.addError(error);
      setData({});
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, [companyId]);

  const closeModal = (): void => {
    return setShowModal(false);
  };

  const openModal = (): void => {
    return setShowModal(true);
  };

  return (
    <Card
      loading={loading}
      testId="po-numbers"
      subtitle={i18n.translate("title.purchase_order_numbers")}
    >
      {data.rewardsPONumber || data.subscriptionPONumber ? (
        <div data-testid="po-numbers-container">
          <EditPONumbersIcon openModal={openModal} type="edit" />
          <StyledLabel>
            {i18n.translate(
              "admin_pages.settings.billing.po_numbers.subscription"
            )}
          </StyledLabel>
          <StyledTextWithMargin data-testid="subscription-po">
            {data.subscriptionPONumber
              ? `#${data.subscriptionPONumber}`
              : i18n.translate(
                  "admin_pages.settings.billing.po_numbers.not_added"
                )}
          </StyledTextWithMargin>
          <StyledLabel>
            {i18n.translate("admin_pages.settings.billing.po_numbers.reward")}
          </StyledLabel>
          <StyledText data-testid="rewards-po">
            {data.rewardsPONumber
              ? `#${data.rewardsPONumber}`
              : i18n.translate(
                  "admin_pages.settings.billing.po_numbers.not_added"
                )}
          </StyledText>
        </div>
      ) : (
        <div data-testid="no-po-numbers">
          <EditPONumbersIcon openModal={openModal} type="add" />
          <StyledText>
            {i18n.translate(
              "admin_pages.settings.billing.po_numbers.none_added"
            )}
          </StyledText>
        </div>
      )}
      <Modal
        ariaLabel="purchase order numbers modal"
        close={closeModal}
        showDialog={showModal}
        testId="po-numbers-modal"
        title={i18n.translate(
          "admin_pages.settings.billing.po_numbers.modal_title"
        )}
      >
        <UpdatePONumbersModalBody
          closeModal={closeModal}
          companyId={companyId}
          fetchData={fetchData}
          rewardsPONumber={data.rewardsPONumber}
          subscriptionPONumber={data.subscriptionPONumber}
          updateToastMessage={updateToastMessage}
        />
      </Modal>
    </Card>
  );
};

export default PurchaseOrderNumbersCard;
